import React, { useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Logo from "../Assets/logo01.png";
import { useAuth } from "./context/AuthProvider";
import Loader from "./Loader";

const StudentInvoice = ({ student, setShowInvice }) => {
  const { user } = useAuth()
  const [loading, setLoading] = useState(false)

  const printInvoice = async () => {
    const invoiceElement = document.getElementById("invoice");
    if (!invoiceElement) return;

    setLoading(true);

    try {
      const canvas = await html2canvas(invoiceElement, { scale: 2 });
      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", [80, 297]);
      const imgWidth = 80;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);

      const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

      if (isMobile) {
        // 📱 Mobile: open PDF in new tab
        const blobUrl = pdf.output("bloburl");
        const win = window.open(blobUrl, "_blank");
        win.onload = () => {
          win.focus();
          win.print();
        };
      } else {
        // 💻 Desktop: auto print
        pdf.autoPrint();
        const iframe = document.createElement("iframe");
        iframe.style.position = "fixed";
        iframe.style.right = "0";
        iframe.style.bottom = "0";
        iframe.style.width = "0";
        iframe.style.height = "0";
        iframe.style.border = "0";

        iframe.src = pdf.output("bloburl");
        document.body.appendChild(iframe);

        iframe.onload = () => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          setLoading(false);
        };
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };


  const downloadPDF = () => {
    const invoiceElement = document.getElementById("invoice");
    if (!invoiceElement) return;

    setLoading(true);

    html2canvas(invoiceElement, { scale: 2 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", [80, 297]); // Thermal printer size: 80mm width, 297mm height (A4 height)
      const imgWidth = 80; // Thermal printer width in mm
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      pdf.save(`invoice.pdf`);
      setLoading(false);
    }).catch((error) => {
      console.error("Error generating PDF:", error);
      setLoading(false);
    });
  };

  return (
    <>
      {loading && <Loader />}
      <div className="mt-8 flex justify-end gap-5 m-5">
        <button
          className=" bg-primary text-white px-4 py-2 rounded-md"
          onClick={() => setShowInvice(false)}
        >
          Close
        </button>
        <button
          onClick={printInvoice}
          className="px-6 py-2 bg-blue-600 text-white font-bold rounded-lg shadow hover:bg-blue-500"
        >
          Print
        </button>
        <button
          onClick={downloadPDF}
          className="px-6 py-2 bg-blue-600 text-white font-bold rounded-lg shadow hover:bg-blue-500"
        >
          Download as PDF
        </button>
      </div>
      <div
        className="section mx-auto p-4 bg-white  min-w-[80mm] max-w-[80mm]"
        style={{ fontSize: '12px' }}
        id="invoice"
      >
        <div className="border-b pb-4 mb-4 flex flex-col">
          <div>
            <img src={Logo} alt="logo" className="w-full h-auto" />
          </div>
          <div className="text-left">
            <h1 className="font-bold text-black" style={{ fontSize: '12px' }}>Invoice</h1>
            {student?.invoiceNo && <p className="text-black">{student?.invoiceNo}</p>}
            <p className="text-black">Name : {student.name}</p>
            <p className="text-black">Class : {student.class}</p>
            <p className="text-black">House : {student.house}</p>
            <p className="text-black">Phone : {student.phone}</p>
            {student?.invoices?.length >0  && <p className="text-black">Date : {new Date(student?.invoices?.find(
              (inv) => inv.invoiceNo === student?.invoiceNo
            )?.createdAt || "").toLocaleDateString('en-GB')} - {new Date(student?.invoices?.find(
              (inv) => inv.invoiceNo === student?.invoiceNo
                )?.createdAt || "").toLocaleTimeString()}</p>}
            {user.role === "super-admin" && (
              <p className="text-black">
                Taken By :{" "}
                {student?.invoices?.find(
                  (inv) => inv.invoiceNo === student?.invoiceNo
                )?.takenBy || "-"}
              </p>
            )}
          </div>
        </div>

        <div>
          {student.products.length > 0 ? (
            <div className="space-y-6">
              <h2 className="font-semibold text-black" style={{ fontSize: '12px' }}>
                Product Summary
              </h2>
              <table className="min-w-full border-collapse border border-gray-300">
                <thead className="bg-gray-100">
                  <tr>
                    <th className="border border-gray-300 px-1 py-1 text-left text-gray-700" style={{ fontSize: '12px' }}>
                      S.No
                    </th>
                    <th className="border border-gray-300 px-1 py-1 text-left text-gray-700" style={{ fontSize: '12px' }}>
                      Product
                    </th>
                    <th className="border border-gray-300 px-1 py-1 text-left text-gray-700" style={{ fontSize: '12px' }}>
                      Qty
                    </th>
                    <th className="border border-gray-300 px-1 py-1 text-left text-gray-700" style={{ fontSize: '12px' }}>
                      Price
                    </th>
                    <th className="border border-gray-300 px-1 py-1 text-left text-gray-700" style={{ fontSize: '12px' }}>
                      Total
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {student.products.map((item, idx) => (
                    <tr key={idx} className="hover:bg-gray-100">
                      <td className="border border-gray-300 px-1 py-1">
                        {idx + 1}
                      </td>
                      <td className="border border-gray-300 px-1 py-1 capitalize">
                        {item.product?.name || "custom product"}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        {item.quantity}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        &#8377; {item.product?.price || item.price}
                      </td>
                      <td className="border border-gray-300 px-1 py-1">
                        &#8377;{" "}
                        {item.quantity * (item.product?.price || item.price)}
                      </td>
                    </tr>
                  ))}
                 { student.paymentDetails?.payments?.some(payment => payment.method === "cash") &&
                   <tr className="bg-gray-100 font-bold">
                   <td colSpan={3} className="border border-gray-300 px-1 py-1 text-right">
                     Payment
                   </td>
                   <td className="border border-gray-300 px-1 py-1 text-center">
                     <span className="">Cash</span>
                   </td>
                   <td className="border border-gray-300 px-1 py-1 text-right font-semibold">
                     &#8377;{" "}{student.paymentDetails?.payments
                       .filter(payment => payment.method === "cash")
                       .reduce((total, payment) => total + payment.amount, 0)}
                   </td>

                 </tr>
                 }
                   {
                      student.paymentDetails?.payments?.some(payment => payment.method === "gpay") &&
                      <tr className="bg-gray-100 font-bold">
                        {!student.paymentDetails?.payments?.every(payment => payment.method === "gpay") ?
                         <td colSpan={3}></td>
                        :<td colSpan={3} className="border border-gray-300 px-1 py-1 text-right">
                         Payment
                       </td>}
                        <td className="border border-gray-300 px-1 py-1 text-center">
                          <span className="">GPay</span>
                        </td>
                        <td className="border border-gray-300 px-1 py-1 text-right font-semibold">
                          &#8377;{" "}{student.paymentDetails?.payments
                            .filter(payment => payment.method === "gpay")
                            .reduce((total, payment) => total + payment.amount, 0)}
                        </td>

                      </tr>
                   }
                   {
                   student.paymentDetails?.payments?.filter(p=>p?.discount>0) &&
                   <tr className="bg-gray-100 font-bold">
                     <td
                       className="border border-gray-300 px-1 py-1 text-right"
                       colSpan="4"
                     >
                       Discount Amount
                     </td>
                     <td className="border border-gray-300 text-right px-1 py-1">
                       &#8377;{" "}{student.paymentDetails?.payments?.reduce((acc,cur)=>{
                         return acc + cur.discount
                       },0)}
                     </td>
                   </tr>}
                   <tr className="bg-gray-100 font-bold">
                     <td
                       className="border border-gray-300 px-1 py-1 text-right"
                       colSpan="4"
                     >
                       Balance Amount
                     </td>
                     <td className="border border-gray-300 text-right px-1 py-1">
                       &#8377;{" "}{student.paymentDetails?.balance}
                     </td>
                   </tr>
                   <tr className="bg-gray-100 font-bold">
                     <td
                       className="border border-gray-300 px-1 py-1 text-right"
                       colSpan="4"
                     >
                       Grand Total
                     </td>
                     <td className="border border-gray-300 text-right px-1 py-1">
                       &#8377;{" "}
                       {student.paymentDetails.totalPrice}
                     </td>
                   </tr>
                </tbody>
              </table>
              <div className="mt-3 pt-2 border-t border-dashed border-gray-400 text-left">
                <p className="font-semibold text-black" style={{ fontSize: '11px' }}>
                  Terms & Conditions:
                </p>
                <p className="text-black mt-1" style={{ fontSize: '10px', lineHeight: '1.2' }}>
                  The above sizes were finalized in the presence of parents, hence it is considered to be approved by parent of student.
                </p>
              </div>
              <p className="text-black text-center mt-2" style={{ fontSize: '12px' }}>Thank you</p>
            </div>
          ) : (
            <p className="text-black">No products to display.</p>
          )}
        </div>
      </div>
    </>
  );
};

export default StudentInvoice;
